import CurrencyConverter from "@heartinz/currency_subunit_converter";
import uRLs from "../../../utils/baseUtils";
import { usePermission } from "../../../context/PermissionContext";

export default function MenuCategoryList({ items = [], onItemClick }) {
  const { permission, hasPermission, viewOption, setGlobelPopupOpen ,blockedPermissions} =
    usePermission();
  return (
    <div className="container py-3">
      <div className="row g-3">
        {items.map((it, idx) => {
          const isDefaultImage =
            !it.product?.primaryImage ||
            it.product?.primaryImage === "/assets/images/avatars/default.jpg";

          const imgUrl = isDefaultImage
            ? "/assets/images/avatars/default.jpg"
            : uRLs.IMAGE_URL + it.product?.primaryImage;

          const mrp = it.product?.mrp || 0;
          const sale = it.product?.saleprice || 0;

          // Discount rounded down (floor) and only show if >= 1%
          const discount =
            mrp > sale ? Math.floor(((mrp - sale) / mrp) * 100) : 0;

          return (
            <div className="col-lg-4 col-md-6 col-sm-12" key={idx}>
              <div
                className="position-relative w-100 border-0 bg-transparent p-0"
                onClick={() => onItemClick?.(it.productid)}
                style={{ cursor: "pointer" }}
              >
                <div
                  className="d-flex align-items-center bg-white rounded-2 shadow-sm"
                  style={{ transition: "all 0.3s ease-in-out" }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.transform = "scale(1.03)")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.transform = "scale(1)")
                  }
                >
                  {/* Left: Product image */}
                  {uRLs.ADD_PRODUCT_IMAGE === "true" &&
              viewOption("generalSettings", "isProductImage") && (
                  <div
                    className=" flex-shrink-0 overflow-hidden rounded-start"
                    style={{ width: 75, height: 75, background: "#f9f9f9" }}
                  >
                    <img
                      src={imgUrl}
                      alt={it.product?.title || "Product"}
                      className="w-100 h-100 object-fit-cover"
                    />
                  </div>)}

                  {/* Middle: Product info */}
                  <div className="flex-grow-1 text-start mt-1 mb-1 ms-3">
                    <div
                      className="fw-normal"
                      style={{
                        fontSize: 12,
                        minHeight: "2.5rem",
                        display: "-webkit-box",
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: "vertical",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {it.product?.title}
                    </div>

                    <div
                      className="text-muted d-flex align-items-center flex-wrap"
                      style={{ fontSize: 11 }}
                    >
                      {/* Discount % (only if >= 1%) */}
                      {discount >= 1 && (
                        <span
                          className="text-danger fw-bold me-2"
                          style={{ fontSize: 12 }}
                        >
                          {discount}% OFF
                        </span>
                      )}

                      {/* MRP (only if greater than saleprice) */}
                      {mrp > sale && (
                        <span className="text-decoration-line-through me-2">
                          ₹{CurrencyConverter.toCurrency(mrp, "INR")}
                        </span>
                      )}

                      {/* Sale Price */}
                      <span className="badge bg-label-fall rounded-pill me-2">
                        ₹{CurrencyConverter.toCurrency(sale, "INR")}
                      </span>

                      {/* Stock */}
                      {it?.product?.isStock === true && (
                        <span className="badge bg-label-space rounded-pill">
                          Stock: {it?.totalStockLeft}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
